import React from "react";

const SuggestionButton = ({ suggestion, onClick }) => {
    return (
        <div
            className="suggestion-item"
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) onClick(suggestion.value);
            }}
        >
            {suggestion.icon && (
                <span className="suggestion-icon">
                    {suggestion.icon}
                </span>
            )}
            <span>{suggestion.label}</span>
        </div>
    );
};

export default SuggestionButton;

